var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAnnouncement01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 7.99998V12M10.25 5.49997H6.8C5.11984 5.49997 4.27976 5.49997 3.63803 5.82695C3.07354 6.11457 2.6146 6.57352 2.32698 7.138C2 7.77974 2 8.61982 2 10.3L2 11.5C2 12.4319 2 12.8978 2.15224 13.2653C2.35523 13.7554 2.74458 14.1447 3.23463 14.3477C3.60218 14.5 4.06812 14.5 5 14.5V18.75C5 18.9821 5 19.0982 5.00963 19.196C5.10316 20.1456 5.85441 20.8968 6.80397 20.9903C6.90175 21 7.01783 21 7.25 21C7.48217 21 7.59826 21 7.69604 20.9903C8.64559 20.8968 9.39685 20.1456 9.49037 19.196C9.5 19.0982 9.5 18.9821 9.5 18.75V14.5H10.25C12.0164 14.5 14.1772 15.4469 15.8443 16.3556C16.8168 16.8858 17.3031 17.1508 17.6216 17.1118C17.9169 17.0757 18.1402 16.9431 18.3133 16.7011C18.5 16.4401 18.5 15.918 18.5 14.8737V5.12626C18.5 4.08197 18.5 3.55982 18.3133 3.29886C18.1402 3.05687 17.9169 2.92427 17.6216 2.8881C17.3031 2.84909 16.8168 3.11417 15.8443 3.64433C14.1772 4.55309 12.0164 5.49997 10.25 5.49997Z",
    stroke: "#070707",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnnouncement01);
export default __webpack_public_path__ + "static/media/announcement-01.241e41e4c926ad6f7c3124f39c68bbe5.svg";
export { ForwardRef as ReactComponent };